import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import {
  showPrice,
  splatPriceDisplayDiscountAndOriginalPrice,
} from '../../helpers/deals';

const PriceSplat = ({ deal = {}, isVisible = false }) => {
  const router = useRouter();
  const path = router.asPath || '';
  const [
    displayDiscountAndOriginalPrice,
    setDisplayDiscountAndOriginalPrice,
  ] = useState(false);
  useEffect(() => {
    setDisplayDiscountAndOriginalPrice(
      splatPriceDisplayDiscountAndOriginalPrice({
        deal,
        isTwoByTwo: true,
        path,
      }),
    );
  }, [deal, path]);
  if (
    !isVisible ||
    (!deal?.discountPercentage && displayDiscountAndOriginalPrice)
  )
    return null;

  return (
    <div className="splat">
      <div className="splat__text">
        <p className="splat__now">
          {displayDiscountAndOriginalPrice ? 'SAVE' : deal.priceText}
        </p>
        <p
          className="splat__price"
          dangerouslySetInnerHTML={{
            __html: displayDiscountAndOriginalPrice
              ? `${deal?.discountPercentage}%`
              : showPrice({
                  currency: deal.currency,
                  dealPrice: deal.price,
                  forceDecimals: true,
                  pricePerPerson: false,
                }),
          }}
        />
        <p
          className="splat__original-price"
          dangerouslySetInnerHTML={{
            __html: showPrice({
              currency: deal.currency,
              dealPrice: deal.originalPrice,
              forceDecimals: true,
              pricePerPerson: false,
            }),
          }}
        />
      </div>
      <style jsx>{`
        .splat {
          width: 85px;
          height: 85px;
          overflow: hidden;
          position: absolute;
          bottom: 0;
          right: 0;
          background: url('https://resources.wowcher.co.uk/images/splat.svg')
            no-repeat;
          z-index: 100;
          cursor: pointer;
          pointer-events: none;
          transform: rotateY(0deg);
          background-position: 10px 12px;
          background-size: 100px;
        }

        .splat__text {
          z-index: 999;
          position: absolute;
          bottom: 4px;
          right: 0;
          color: #ffffff;
          margin: 0;
          text-align: center;
          line-height: 1em;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          min-width: 54px;
          min-height: 38px;
          font-size: 17px;
        }

        .splat__now {
          font-size: 0.7em;
          text-transform: uppercase;
          font-weight: bold;
          line-height: 1em;
          margin: 0;
        }

        .splat__price {
          font-weight: bold;
          line-height: 1.2em;
          margin: 0;
        }

        .splat__original-price {
          position: relative;
          font-size: 0.6em;
          line-height: 1em;
          margin: 0;
        }

        .splat__original-price:before {
          position: absolute;
          content: '';
          left: 0;
          top: 50%;
          right: 0;
          width: 120%;
          margin-left: -10%;
          border-top: 1px solid;
          -webkit-transform: rotate(-11deg);
          -ms-transform: rotate(-11deg);
          transform: rotate(-11deg);
        }

        @media (min-width: 576px) {
          .splat {
            background-position: 10px 12px;
            background-size: 100px;
          }

          .splat__text {
            font-size: 19px;
            min-height: 45px;
          }
        }
      `}</style>
    </div>
  );
};

PriceSplat.propTypes = {
  deal: PropTypes.object,
  isVisible: PropTypes.bool,
};

export default PriceSplat;
